import React, { useState, useEffect } from "react";
import {  getHistoricoManutencao } from "../../services/api_historico_manutencao";
import HistoricoForm from "../../components/Relatorios/gerarHistorico";
import RelatorioHistoricoManutencao from "../../components/Relatorios/historicoManutencao";
import Swal from "sweetalert2";
import dataFormatada from "../../hooks/Date/dataFormatada";
import dataHoraFormatada from "../../hooks/Date/dataHoraFormatada";

const HistoricoPage = (props) => {
    const [showForm, setShowForm] = useState(true);
    const [showRelatorio, setShowRelatorio] = useState(false);
    const [filtro, setFiltro] = useState({});
    const [dadosRelatorio, setDadosRelatorio] = useState([]);
    const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (loading) {
      Swal.fire({
        title: "Gerando relatório...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    } else {
      Swal.close();
    }
  }, [loading]);

  

    
  
const handleGenerateRelatorio = async (filtro) => {
    try {
    setLoading(true);
      let body = {
        idEmpresa: filtro.empresa,
        idUnidade: filtro.unidade,
        idTipoAplicacao: filtro.tipoAplicacao,
        idAplicacao: filtro.id_aplicacao,
        idManutentor: filtro.id_pessoa,
        idSolicitante: filtro.id_user_gerou,
        dataInicial: filtro.dataInicial, 
        dataFinal: filtro.dataFinal
      }

      const dados = await getHistoricoManutencao(body);
  
        console.log("eita:", dados);
  
        setFiltro({
          nomeEmpresa: filtro.nomeEmpresa,
          nomeUnidade: filtro.nomeUnidade,
          descricaoTipoAplicacao: filtro.descricaoTipoAplicacao,
          nomeManutentor: filtro.nomeManutentor,
          nomeSolicitante: filtro.nomeSolicitante,
          dataInicial: filtro.dataInicial, 
          dataFinal: filtro.dataFinal

        });
        setDadosRelatorio(dados);
        setShowForm(false);
        setShowRelatorio(true);
        setLoading(false);

      console.log(dados)
      
    } catch (error) {
      console.error("Erro ao gerar relatório:", error);
    }
  };
  
  
    return (
      <div>
        {showForm && (
          <HistoricoForm
            show={showForm}
            handleClose={() => setShowForm(false)}
            handleGenerate={handleGenerateRelatorio}
          />
        )}
        {showRelatorio && (
          <RelatorioHistoricoManutencao
            filtro={filtro}
            dataHora={new Date().toLocaleString()}
            dados={dadosRelatorio}
            setShowForm={setShowForm} // Passa a função para mostrar o formulário
            setShowRelatorio={setShowRelatorio} // Passa a função para esconder o relatório
          />
        )}
      </div>
    );
};

export default HistoricoPage;
